angular
  .module("alk.constants")
  /** @name PCMRegion
   * @ngdoc constant
   * @description Provides a list of the supported PCMiler regions recognized by PCMiler Web Services.
   * The constant is the following object:
   * 
   * `{
   * "Unknown": 0,
   * "AF": 1,
   * "AS": 2,
   * "EU": 3,
   * "NA": 4,
   * "OC": 5,
   * "SA": 6,
   * "ME": 7
   * }`
   * @memberof alk.constants
   */
  .constant("PCMRegion", {
    "Unknown": 0,
    "AF": 1,
    "AS": 2,
    "EU": 3,
    "NA": 4,
    "OC": 5,
    "SA": 6,
    "ME": 7
  });



// WEBPACK FOOTER //
// ./~/@trimblemaps/webtools-common/javascript/AngularJS/alk-constants/regions.js